module.exports = __webpack_public_path__ + "static/pepsi_Page_2-f7d8957e51465463771b1f4cba5cb33a.jpg";